import React, {Component} from 'react';
import {Modal, Button, FormGroup, ControlLabel, FormControl, Radio} from 'react-bootstrap';
import axios from 'axios';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import ErrorMessageContainer from "./ErrorMessageContainer";

require('moment/locale/el');

export default class ContractResearchCompletedModal extends Component {
    constructor() {
        super();

        this.state = {
            research_completed_at: moment(),
            research_completed: 0,
            submit_disabled: false,
            validationErrors: []
        };

        this.getData = this.getData.bind(this);
        this.close = this.close.bind(this);
        this.submit = this.submit.bind(this);
        this.radioChange = this.radioChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        this.getData();
    }

    getData() {
        let url = "/contracts/ajax/manage_contracts/" + this.props.contractId + "/research_completed";
        axios
            .get(url)
            .then((response) => {
                let research_completed_at = response.data;

                if (research_completed_at === null)
                    research_completed_at = moment();
                else if (research_completed_at === "")
                    research_completed_at = "";
                else
                    research_completed_at = moment(research_completed_at, "DD/MM/YYYY");

                this.setState({
                    research_completed: (response.data !== null ? 1 : 0),
                    research_completed_at: research_completed_at
                });
            });
    }

    close() {
        this.props.closeCallback();
    }

    submit() {
        if (!this.state.submit_disabled) {
            this.setState({
                validationErrors: [],
                submit_disabled: true
            }, () => {
                let url = "/contracts/ajax/manage_contracts/" + this.props.contractId + "/research_completed";

                let research_completed_at = null;
                if (this.state.research_completed === 1) {
                    if (this.state.research_completed_at === "" || this.state.research_completed_at === null)
                        research_completed_at = "";
                    else
                        research_completed_at = this.state.research_completed_at.format("DD/MM/YYYY");
                }

                axios
                    .post(url, {
                        research_completed: this.state.research_completed,
                        research_completed_at: research_completed_at
                    })
                    .then((response) => {
                        this.setState({submit_disabled: false}, () => {
                            this.close();
                        });
                    })
                    .catch((failure) => {
                        this.setState({
                            validationErrors: failure.response.data,
                            submit_disabled: false
                        });
                    });
            });
        }
    }

    radioChange(value) {
        this.setState({research_completed: value});
    }

    handleDateChange(date) {
        this.setState({research_completed_at: date});
    }

    render() {
        return (
            <Modal show={this.props.showModal}
                   onHide={this.close}>
                <Modal.Header closeButton>
                    <Modal.Title>{window.__js_contracts.research_completion_tracking}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ErrorMessageContainer errors={this.state.validationErrors}/>

                    <FormGroup>
                        <Radio name="research_completed"
                               value="0"
                               checked={this.state.research_completed === 0}
                               onChange={() => this.radioChange(0)}>
                            {window.__js_contracts.research_not_finished}
                        </Radio>
                        <Radio name="research_completed"
                               value="1"
                               checked={this.state.research_completed === 1}
                               onChange={() => this.radioChange(1)}>
                            {window.__js_contracts.research_completed}
                        </Radio>
                    </FormGroup>
                    <FormGroup controlId="research_completed_at"
                               className={this.state.research_completed === 1 ? "" : "hidden"}
                               style={{paddingLeft: "20px"}}>
                        <ControlLabel>{window.__js_contracts.completion_date}*</ControlLabel>
                        <DatePicker className="form-control"
                                    name="research_completed_at"
                                    id="research_completed_at"
                                    selected={this.state.research_completed_at}
                                    onChange={this.handleDateChange}
                                    dateFormat="DD/MM/YYYY"
                                    locale="el"/>
                    </FormGroup>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.close}>{window.__js_general.close}</Button>
                    <Button onClick={this.submit}
                            bsStyle="primary"
                            disabled={this.state.submit_disabled}>
                        {window.__js_general.save}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}